<template>
  <div class="card p-10">
    <RequiredText></RequiredText>
    <form id="invoiceForm" @submit.prevent="submitForm">
      <Card class="card p-5">
        <div class="d-flex flex-column flex-md-row">
          <div class="mb-3 mb-md-0 me-md-5 d-flex justify-content-center align-items-center">
            <img v-if="selectedContact && selectedContact.avatar" 
                :src="selectedContact.avatar_url" 
                class="img-fluid rounded-3" 
                style="width: 150px; height: 150px; border-radius: 10px;" />
            <div v-if="selectedContact && !selectedContact.avatar" class="cursor-pointer symbol symbol-30px symbol-md-40px mb-6 d-flex justify-content-center align-items-center">
              <span class="symbol-label fs-2x fw-bold text-primary bg-light-primary d-flex align-items-center justify-content-center" 
                    style="width: 150px; height: 150px; border-radius: 10px;">
                {{ selectedContact.lastname ? selectedContact.lastname.charAt(0).toUpperCase() : "" }}
                {{ selectedContact.firstname ? selectedContact.firstname.charAt(0).toUpperCase() : "" }}
              </span>
            </div>
            <img v-if="!selectedContact" 
                src="/assets/media/avatars/blank.png" 
                class="img-fluid rounded-3" 
                style="width: 150px; height: 150px; border-radius: 10px;" />
          </div>

          <!-- Form Section -->
          <div class="flex-grow-1">
            <div class="row g-3">
              <Select2
                container-class="form-group col-12 col-md-6  col-lg-6"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                :name="`invoice-contact`"
                :label="$t('invoice.label.customer')"
                labelClass="form-label fs-6 text-black"
                :placeholder-text="$t('invoice.label.customer')"
                v-model="formData.contact_id"
                :IsInputGroup="true"
                icon="bi bi-plus"
                :clickAddon="openSupplierModal">
                <option v-for="contact in contacts" :value="contact.id" :key="contact.id">
                  {{ contact.lastname }} {{ contact.firstname }}
                </option>
              </Select2>

              <Select2
                container-class="col-12 col-md-3 col-lg-3"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                name="invoice-payment-mode"
                :label="$t('crm.estimate.label.paymentCondition')"
                labelClass="form-label fs-6 text-black"
                :isRequired="true"
                :placeholderText="$t('crm.estimate.label.paymentCondition')"
                v-model="formData.payment_condition_id">
                <option v-for="(paymentCondition, index) in paymentConditions" :key="index" :value="paymentCondition.id">
                  {{ paymentCondition.name }}
                </option>
              </Select2>

              <Select2
                container-class="col-12 col-md-3 col-lg-3"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                name="invoice-payment-type"
                :label="$t('invoices.label.paymentType')"
                labelClass="form-label fs-6 text-black"
                :isRequired="true"
                :placeholderText="$t('invoices.label.paymentType')"
                v-model="formData.payment_type_id">
                <option v-for="paymentType in paymentTypes" :value="paymentType.id" :key="paymentType.id">
                  {{ paymentType.name }}
                </option>
              </Select2>

              <Select2
                container-class="col-12 col-md-6  col-lg-6"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                name="invoice-currency"
                :label="$t('invoice.label.currency')"
                labelClass="form-label fs-6 text-black"
                :isRequired="true"
                :placeholderText="$t('invoice.label.currency')"
                v-model="formData.currency_id">
                <option v-for="(currency, index) in currencies" :key="index" :value="currency.id">
                  {{ currency.name + ' (' +  currency?.iso + ')'}}
                </option>
              </Select2>

              <Input
                v-show="discountCurrencyIso !== companyCurrency?.iso"
                containerClass="col-12 col-md-6  col-lg-6"
                name="invoice-exchange"
                type="text"
                :label="$t('invoice.label.exchange')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="true"
                size="lg"
                :placeholder="$t('invoice.placeholder.exchange')"
                v-model="formData.exchange_rate"
                :IsInputGroup="true"
                addon-class="border-0 border-end"
                iconDir="left"
                :iconText="'1 '+ discountCurrencyIso +' ='">
                <template #rightAddon>
                  <span class="position-absolute end-0 top-50 translate-middle-y me-3 text-muted fw-bolder">
                    {{ companyCurrency?.iso }}
                  </span>
                </template>
              </Input>

            </div>
          </div>
        </div>
      </Card>

      <Card class="card my-5 p-5">
        <div class="flex-column current">
          <div class="row mt-5" >
            <div class="col-12 col-md-3 col-lg-3"> 
              <label class="form-label fs-6 text-black">{{ $t('appointments.label.frequence') }}</label>
              <div class="input-group">
                <Input
                    containerClass="form-group col-3 col-md-3 col-lg-3 mt-auto mb-5"
                    :name="`frequence_number`"
                    type="number"
                    :min="0"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="false"
                    v-model="formData.frequency_count"
                    :placeholder="$t('appointments.label.placeholder_reminder_number')"
                />
                <CustomSelect2
                    container-class="form-group col-9 col-md-9 col-lg-9 mt-auto mb-5"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-sm form-select-solid'"
                    :name="`recurrence`"
                    :isRequired="false"
                    :placeholder-text="$t('appointments.label.placeholder_recurrence')"
                    :IsInputGroup="true"
                    v-model="formData.frequency"
                >
                  <option v-for="(item, index) in recurrenceFrequencyEnum" :key="index" :value="item.value">
                    {{ item[locale] }}
                  </option>
                  <template #custom>
                    <div class="icon-wrapper">
                      <i class="fas fa-calendar" style="color: rgba(100, 110, 123, 1)"></i>
                    </div>
                  </template>
                </CustomSelect2>
              </div>
            </div>
            <InputDate
                containerClass="col-12 col-md-3 col-lg-3 mt-auto mb-5"
                name="appointments-recurrence_start_time"
                :label="$t('invoice.label.recurrent.startDate')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="true" size="lg"
                dateFormat="dd-MM-yyyy"
                :placeholder="$t('invoice.label.recurrent.startDate')"
                v-model="formData.recurring_date"
            />
            <Select2
                :container-class="formData.limit_by == 'none' ? 'form-group col-12 col-md-6 col-lg-6 mt-auto mb-5' : 'form-group col-12 col-md-3 col-lg-3 mt-auto mb-5'"
                :multiple="false"
                :show-search="true"
                :selectClass="'form-select form-control-sm form-select-solid'"
                :name="`stop`"
                :isRequired="false"
                :label="$t('appointments.label.stop')"
                labelClass="form-label fs-6 text-black"
                :placeholder-text="$t('appointments.label.stop')"
                v-model="formData.limit_by"
            >
              <option v-for="(item, index) in recurrenceLimitEnum" :key="index" :value="item.value">
                {{ item[locale] }}
              </option>
            </Select2>
            <InputDate
                containerClass="col-12 col-md-3 mt-auto mb-5"
                name="appointments-recurrence_end_time"
                :label="$t('invoice.label.recurrent.endDate')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-sm form-control-solid'"
                :isRequired="formData.limit_by == 'date'" size="lg"
                dateFormat="dd-MM-yyyy"
                :placeholder="$t('invoice.label.recurrent.endDate')"
                v-model="formData.limit_date"
                v-if="formData.limit_by == 'date'"
            />
            <Input
                containerClass="form-group col-12 col-md-3 mt-auto mb-5"
                :name="`limit_count`"
                type="number"
                :min="0"
                :label="$t('appointments.label.limit_count')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :isRequired="formData.limit_by == 'count'"
                v-if="formData.limit_by == 'count'"
                v-model="formData.limit_count"
            />
            <span class="form-check form-switch form-check-custom form-check-solid visible status_btn" v-if="isEditRoute" >
              <label class="form-label  form-control-sm fs-6 text-black py-1"> {{ $t('invoice.label.recurrent.suspend')}}
                <input type="checkbox"   class="form-check-input online h-20px w-30px"  v-model="formData.status" /><span></span></label>
            </span>'
          </div>
        </div>
      </Card>
      <Card class="card my-5 p-5">
        <div class="flex-column current">
          <div class="table-responsive">
            <table class="table table-flush table-borderless table-head-custom table-vertical-center align-middle gy-7 gx-3"
                   id="estimate-items-datatable">
              <tbody>
              <tr>
                <th style="width: 450px" class="fw-bolder required">
                  {{ $t('invoice.label.item.name') }}
                </th>
                <th style="min-width: 110px" class="fw-bolder required">{{ $t('invoice.label.item.quantity') }}</th>
                <th style="min-width: 180px" class="fw-bolder required">{{ $t('invoice.label.item.price') }}</th>
                <th style="min-width: 180px" class="fw-bolder">{{ $t('invoice.label.item.discount') }}</th>
                <th style="min-width: 400px" class="fw-bolder">{{ $t('invoice.label.item.tax') }}</th>
                <th style="min-width: 180px" class="fw-bolder">{{ $t('invoice.label.item.amount') }}</th>
                <th class="fw-bolder" style="text-align: end !important;"></th>
              </tr>
              <InvoiceFormItem
                  v-for="(item, index) in formData.items"
                  :key="item.product_id"
                  :index="index"
                  :item="item"
                  :symbol="discountCurrencyIso"
                  :selectedItems="selectedItemIds"
                  @delete-item="removeItemRow" />
              <tr>
                <td colspan="7">
                  <div class="justify-content-end align-items-end float-end">
                    <a class="btn btn-primary" @click="addItemRow">
                      {{ $t('invoice.addItem') }}
                    </a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Card>

      <div class="row">
        <div class="col-md-6">

        </div>

        <div class="col-md-6">
          <Card class="card p-5">
            <div class="row">
              <div class="border-bottom border-gray-300">
                <div class="d-flex justify-content-between mb-3">
                  <span class="font-weight-600">{{ $t('invoice.subTotal') }} :</span>
                  <span>{{ $formatLocalAmount(parseFloat(invoiceSubTotal)) }} {{ discountCurrencyIso }}</span>
                </div>
                <div class="d-flex justify-content-between mb-3">
                  <span class="font-weight-600">{{ $t('invoice.label.totalDiscount') }} :</span>
                  <span>{{ $formatLocalAmount(parseFloat(invoiceDiscountTotal)) }} {{ discountCurrencyIso }}</span>
                </div>
              </div>
              <div class="border-bottom border-gray-300 mt-3">
                <div class="d-flex justify-content-between text-warning mb-3">
                  <span class="font-weight-600">{{ $t('invoice.totalHT') }}</span>
                  <span>{{ $formatLocalAmount(parseFloat(invoiceTotalHt)) }} {{ discountCurrencyIso }}</span>
                </div>
                <div class="d-flex justify-content-between mb-3">
                  <span class="font-weight-600">{{ $t('invoice.totalTaxes') }} :</span>
                  <span>{{ $formatLocalAmount(parseFloat(invoiceTaxesTotal)) }} {{ discountCurrencyIso }}</span>
                </div>
              </div>
              <div class="mt-3">
                <div class="d-flex justify-content-between text-warning">
                  <span class="font-weight-600">{{ $t('invoice.totalTtc') }}</span>
                  <span>{{ $formatLocalAmount(parseFloat(invoiceTotalTtc)) }} {{ discountCurrencyIso }}</span>
                </div>
              </div>
            </div>
            <div class="row align-content-end justify-content-end mt-7">
              <div class="col-12 text-primary text-end">
                <span class="fw-bolder fs-2">{{ $t('invoice.total') }} </span>
                <br>
                <span class="fw-bolder fs-3x"> {{ $formatLocalAmount(parseFloat(invoiceTotal)) }} {{ discountCurrencyIso }} </span>
              </div>
            </div>
          </Card>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-10">
        <Button type="cancel" btn-class="btn-sm me-2" btn-text="button.cancel"  @click.prevent="cancel" size="7px 30px"></Button>
        <Button type="submit" v-if="!isPaid" btn-class="btn-sm me-2" btn-text="button.save" size="7px 30px" :isDisabled="submitting" :isLoading="submitting"></Button>
      </div>
    </form>

    <CreateTax @load="afterCreateTax"  id="taxCreateModal"/>

    <div class="modal fade" tabindex="-1" id="contactCreateModal">
      <div class="modal-dialog modal-xl">
        <CreateContact id="contactCreateModal"
                       :get-countries="countries"
                       :contact="formCustomerData"
                       :modal="true"
                       @success="afterCreateNewContact"/>
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, defineProps, onMounted, ref,watch} from 'vue'
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import InputDate from "@/components/InputDate2.vue";
import InvoiceFormItem from "@/components/Invoice/InvoiceFormItem.vue";
import {$formatLocalAmount, addDay} from "@/mixins/Helpers";
import {useDiscountType} from "@/composables/discountType";
import {useStore} from "vuex";
import CreateContact from "@/components/contact/CreateContact.vue";
import {BASE_IMAGE_URL} from "@/services/api";
import CreateTax from "@/components/Tax/CreateTax.vue";
import Card from "@/Modules/CRM/components/Card.vue";
import Button from "@/components/Button.vue";
import CKEditor from "@/components/CKEditor.vue";
import {useRoute, useRouter} from 'vue-router';
import RequiredText from "@/components/RequiredText.vue"
import CustomSelect2 from "@/components/CustomSelect2.vue";
import {useLocales} from "@/composables/locales";

const {discountType} = useDiscountType()
const {locale} = useLocales()
const route = useRoute()
const store = useStore()
const router = useRouter()
const props = defineProps({
  invoice: {
    type: Object,
    default: () => ({
      invoice_date: new Date(),
      items: [{
        product_id: '',
        quantity: 1,
        price: 0,
        description: '',
        discount_type: 'percent',
        discount_value: 0,
        taxes: [],
        total: 0
      }],
      taxes: [],

      opportunity_id: '',
      payment_type_id: '',
      recurring_date: null,
      status: '',
      frequency: '',
      limit_by: 'none',
      limit_count: null,
      frequency_count: null,
      limit_date: null,
    })
  },
  isPaid: {type: Boolean, default: false},
  submitForm: Function,
  submitting: {type: Boolean, default: false}
})
const isEditRoute = computed(() => route.name === 'recurrent-invoices-edit');

const formData = ref(props.invoice)

const formCustomerData = ref({
  id: null,
  gender: null,
  contactType: 'particular',
  lastname: null,
  firstname: null,
  address: {
    street: null,
    street2: null,
    city: null,
    zipcode: null,
    country: null
  },
  customer: false,
  propspect: false,
  birthday: null,
  supplier: true,
  telephone: [],
  previewAvatar: BASE_IMAGE_URL + '/assets/blank.png',
  email: null,
  website: null
})
const recurrenceLimitEnum = computed(() => store.getters["appointments/getRecurrenceLimitEnum"])
const recurrenceFrequencyEnum = computed(() => store.getters["appointments/getRecurrenceFrequencyEnum"])

const contacts = computed(() => store.getters['contacts/getContacts'])
const taxes = computed(() => store.getters['taxes/getTaxes'])
const countries = computed(() => store.getters['countries/getCountries'])
const currencies = computed(() => store.getters['currencies/getCurrencies'])
const paymentConditions = computed(() => store.getters['payments/paymentConditions'])
const companyCurrency = computed(() => store.getters['company/getCompanyCurrency'])
const paymentTypes = computed(() => store.getters['payments/paymentTypes'])
const selectedContact = computed(() => {
  return contacts.value.find(contact => contact.id === formData.value.contact_id);
})
const selectedItemIds = computed(() => formData.value.items.map(el => el.product_id))
const invoiceSubTotal = computed(() => formData.value?.items?.reduce((acc, cur) => acc += cur.price * cur.quantity, 0))

const invoiceDiscountTotal = computed(() => {
  let itemDiscounts = 0
  formData.value.items?.filter((item) => {
    if(item.discount_value){
      let discount = applyDiscount(item.discount_type, item.discount_value, item.price * item.quantity)
      itemDiscounts += parseFloat(discount)
    }
  });

  return itemDiscounts
})
const invoiceTotalHt = computed(() => parseFloat(invoiceSubTotal.value) - parseFloat(invoiceDiscountTotal.value))

const invoiceTaxesTotal = computed(() => {
  let itemTaxes = 0
  formData.value.items?.filter((item) => {
    let total = 0
    const orderTaxesSelected = taxes.value?.filter(tax => item.taxes?.includes(tax.id))

    let discountItem = applyDiscount(item.discount_type, item.discount_value, item.price * item.quantity)
    let invoiceItemTotal = parseFloat(item.price) * parseFloat(item.quantity) - parseFloat(discountItem)

    if (orderTaxesSelected.length > 0) {
      const totalTaxesPrice = orderTaxesSelected?.reduce((accumulator, tax) => {
        if (tax.type === 'amount') {
          accumulator.accAmount += parseFloat(tax.amount);
        } else {
          accumulator.accPercent += (invoiceItemTotal * parseFloat(tax.amount) / 100);
        }
        return accumulator
      }, { accAmount: 0, accPercent: 0 })
      total = parseFloat(totalTaxesPrice.accAmount) + parseFloat(totalTaxesPrice.accPercent)
    }
    itemTaxes += parseFloat(total)
  });

  return parseFloat(itemTaxes)
})

const invoiceTotalTtc = computed(() => {
  return parseFloat(invoiceTotalHt.value) + parseFloat(invoiceTaxesTotal.value)
})

const invoiceTotal = computed(() => {
  return invoiceSubTotal.value + invoiceTaxesTotal.value - invoiceDiscountTotal.value
})

const discountCurrencyIso = computed(() => {
  if(!formData.value.currency_id) {
    return  discountType.value.fixed.symbol
  }
  return currencies.value.find(el => el.id === formData.value.currency_id)?.iso
})

const updateCurrencyId = () => {
  if (selectedContact.value && selectedContact.value.currency_id) {
    formData.value.currency_id = selectedContact.value.currency_id;
  } else {
    formData.value.currency_id = null;
  }
};


onMounted(() => {
  store.dispatch('appointments/loadFrequencyEnum')
  store.dispatch('appointments/loadRecurrenceLimitEnum')
  store.dispatch('appointments/loadRecurrenceFrequencyEnum')

})

watch(() =>  formData.value.status, (value) => {
  if(value == true){
    formData.value.status = 'on_hold'
  }else {
    formData.value.status = 'active'
  }
})

watch(() => formData.value.contact_id, (newContactId) => {
  updateCurrencyId();
});

watch(() => formData.value.payment_condition_id, (value) => {
  if(value){
    let filterPayment = paymentConditions.value?.filter((payment) => payment.id == value)
    if(filterPayment){
      if(filterPayment[0]?.day){
        let date = addDay(formData.value.invoice_date, filterPayment[0]?.day)
        formData.value.due_date = date
      }else{
        formData.value.due_date = formData.value.invoice_date
      }
    }
  }
});

function cancel(){
  router.push({ name: 'invoices'})
}

function applyDiscount (discountType, discountVal, amount) {
  if (discountType !== 'amount') {
    return (amount * parseFloat(discountVal || 0 ) / 100)
  }
  return parseFloat(discountVal) || 0
}

function openSupplierModal() {
  $('#contactCreateModal').modal('toggle')
}

function addItemRow() {
  formData.value.items.push({
    product_id: '',
    quantity: 1,
    price: 0,
    description: '',
    discount_type: 'percent',
    discount_value: 0,
    taxes: [],
    total: 0
  })
}

const loadContactCurrency = async () => {
  if(route.params.id){
    await store.dispatch('contacts/getContact', invoice.value.contact_id) .then((response) => {
      invoice.value.currency_id = response.data.contact?.currency_id
    })
  }
}

function removeItemRow(index) {
  if (formData.value.items.length > 1) {
    formData.value.items.splice(index, 1)
  }
}

function afterCreateTax(tax) {
  $("#taxCreateModal").modal('toggle')
  formData.value.taxes.push(tax?.id)
}

function afterCreateNewContact(contact){
  reloadContacts()
  formData.value.contact_id = contact.id
  formCustomerData.value = {
    id: null,
    gender: null,
    contactType: 'particular',
    lastname: null,
    firstname: null,
    address: {
      street: null,
      street2: null,
      city: null,
      zipcode: null,
      country: null
    },
    customer: false,
    birthday: null,
    supplier: true,
    telephone: [],
    previewAvatar: BASE_IMAGE_URL + '/assets/blank.png',
    email: null,
    website: null
  }
}

async function reloadContacts() {
  await store.dispatch('contacts/loadContacts')
}

</script>

<style scoped>

</style>
